export const TEAM_AUTHOR = {
  slug: "team",
  name: "Team Idea 360",
  role: "Redazione Idea 360 Consulting",
  linkedin: "https://www.linkedin.com/company/idea360consulting",
};

export const AUTHORS = [
  {
    slug: "valentina-olivo",
    name: "Valentina Olivo",
    role: "Referente Marketing e Organizzazione aziendale",
    linkedin: "https://www.linkedin.com/in/vol/",
    blog: ["Marketing", "Organizzazione"],
    faq: ["Marketing", "Metodo"],
  },
  {
    slug: "francesco-cretella",
    name: "Francesco Cretella",
    role: "Referente Finanza, Contabilità e Business plan",
    linkedin: "https://www.linkedin.com/in/francesco-cretella-5a297040b/",
    blog: ["Finance"],
    faq: ["Finanza agevolata", "Finanza e controllo", "Avvio impresa"],
  },
  {
    slug: "clelia-nappo",
    name: "Clelia Nappo",
    role: "Referente Risorse umane",
    linkedin: "https://www.linkedin.com/in/clelia-nappo-0403a922a/",
    blog: ["HR"],
    faq: ["Persone e lavoro"],
  },
];

const norm = (s) => (s || "").trim().toLowerCase();

export const authorForBlog = (post) => {
  if (post?.author?.name) {
    const known = AUTHORS.find((a) => norm(a.name) === norm(post.author.name));
    if (known) return known;
    return { slug: "hubspot", name: post.author.name, role: "Idea 360 Consulting", linkedin: post.author.linkedin || TEAM_AUTHOR.linkedin };
  }
  return AUTHORS.find((a) => a.blog.includes(post?.category)) || TEAM_AUTHOR;
};

export const authorForFaq = (faq) => AUTHORS.find((a) => a.faq.includes(faq?.category)) || TEAM_AUTHOR;
